import { render, staticRenderFns } from "./marketZoneAttr.vue?vue&type=template&id=bb98992c&scoped=true"
import script from "./marketZoneAttr.vue?vue&type=script&lang=js"
export * from "./marketZoneAttr.vue?vue&type=script&lang=js"
import style0 from "./marketZoneAttr.vue?vue&type=style&index=0&id=bb98992c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb98992c",
  null
  
)

component.options.__file = "marketZoneAttr.vue"
export default component.exports